import { render, staticRenderFns } from "./DetailCardTranslatedValue.vue?vue&type=template&id=92a14c5a&scoped=true"
import script from "./DetailCardTranslatedValue.vue?vue&type=script&lang=ts"
export * from "./DetailCardTranslatedValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a14c5a",
  null
  
)

export default component.exports